export const PRIVILEGES = {
  AMC: 'AMC',
  AUTO: 'AUTO',
  ASI: 'ASI',
  MRH: 'MRH',
  EPARGN: 'EPARGN',
};
export const EXCLUDED_TYPES = [PRIVILEGES.ASI];
export const mapsUrl =
  'https://www.google.com/maps/search/saham+assurance/@33.5677858,-7.7180891,12z/data=!3m1!4b1';

export const CONTRACT_STATUSES = {
  TERMINATED: 'Résiliée',
  TERMINATED_1: 'Resiliee',
  CONTRACT_PROJECT: 'Contract Project',
  TERMINATED_DEADLINE: 'Résilier a échéance',
  CANCELED: 'Annulé',
  ACTIVE: 'Actifs',
  TERMINATED_DEADLINE_1: 'Resilier a echeance',
  INACTIVE: 'Contract inactif',
  CANCELED_1: 'Annule',
  PENDING: "En Instance d'Acceptation",
  SUSPENDED: 'Suspendue',
  ENDORSEMENT_PROJECT: 'Endorsement Project',
  TERMINATION_PROJECT: 'Projet de resilisation',
  INCOMPLETE: 'Incomplète',
  QUOTE: 'Devis davenant',
  ENCOURS: 'ENCOURS',
};

export const contactMrh = {
  serviceFr: '0522 480 480',
  serviceAr: '480 480 0522',
  agent: '0661 254 135',
};
export const contactAuto = {
  service: '34 34',
  agent: '0522 254 135',
};
export const CGS_EPARGN = {
  AlMoustakbalChaabi:
    'https://cg-mobile.s3.eu-central-1.amazonaws.com/conditions_generales_al_moustakbal_chaabi.pdf',
  AssurRetrait:
    'https://cg-mobile.s3.eu-central-1.amazonaws.com/notice_information_plan_epargne_retraite_collectif.pdf',
  AddamaneChaabi:
    'https://cg-mobile.s3.eu-central-1.amazonaws.com/conditions_generales_addamane_chaabi.pdf',
};

export const appStore = {
  ios:
    'https://itunes.apple.com/fr/app/saham-assurance-maroc/id1216282486?mt=8',
  android:
    'https://play.google.com/store/apps/details?id=ma.tnc.sahamassurance&hl=fr',
};

export const PMI = 'PMI';
export const DRPP = 'DRPP';
export const CONTRACT_TYPE = {
  saving: 'SAVING',
  amc: 'AMC',
  other: 'OTHER',
};

export const CONFIG = {
  amcOcpUrl:
    process.env.REACT_APP_AMC_OCP_URL ||
    'https://ittissal.sanlamallianz.ma/AMCOCP',
  healthCallCenterPhoneNumberFr:
    process.env.HEALTH_CALL_CENTER_PHONE_NUMBER || '05 22 420 606',
  healthCallCenterPhoneNumberAr:
    process.env.HEALTH_CALL_CENTER_PHONE_NUMBER || '606 420 0522',
};

export const MEGA_BYTE = 1000000;

export const COMMON_ACCEPTED_FILE_TYPES = [
  'image/*, application/pdf',
  'application/msword',
  'application/doc',
  'application/docm',
  'application/docx',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const GOOGLE_MAPS = 'https://maps.google.com';

export const POLICY_TO_REPLACE = [
  {
    oldPolicy: '0600996854',
    newPolicy: '0600996854/01',
    maxDate: '31/03/2024',
  },
];
